import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis } from "@/hooks/useLenis";

// Her route (pathname) değişiminde sayfayı en üste sıfırlar. Not: bu, components/site/ScrollToTop.jsx
// (aşağı kaydırınca beliren "yukarı çık" butonu) ile karışmasın diye ayrı bir bileşen — farklı bir amaca hizmet ediyor.
export default function RouteScrollReset() {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname]);

  return null;
}
